import {createContext, useContext} from 'react';

export type Mode = 'pay' | 'setup';

export type SessionContext = {
  publishableKey: string;
  clientSecret: string;
  sessionId: string;
  mode: Mode;
};

export const SessionContext = createContext<SessionContext>({
  publishableKey: '',
  clientSecret: '',
  sessionId: '',
  mode: 'pay',
});

export const useSessionContext = () => {
  return useContext(SessionContext);
};
